import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { accessService } from '../../services/central-api/access';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    includeAllOption?: boolean;
    allowEmpty?: boolean;
    disabled?: boolean;
    zIndex: number;
    required?: boolean;
    labelFontSize?: number;
    semiBoldLabel?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});


function ActingBodiesDropdown({ value, setValue, includeAllOption = true, allowEmpty = false, disabled, zIndex, required, form, fieldName, labelFontSize, semiBoldLabel }: Props) {
    const [selectableActingBodies, setSelectableActingBodies] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodies() {
        try {
            const actingBodies = await accessService.getActingBodies();
            setSelectableActingBodies([
                ...(includeAllOption && !allowEmpty ? [{ value: 0, label: translate('masculineAll') }] : []),
                ...(!includeAllOption && allowEmpty ? [{ value: 0, label: '' }] : []),
                ...actingBodies.map((actingBody) => {
                    return {
                        value: actingBody.id,
                        label: actingBody.name
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    if (form && fieldName) {
        return <FormDropDownPicker
            labelFontSize={labelFontSize}
            label={translate('actingBody')}
            items={selectableActingBodies}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            semiBoldLabel={semiBoldLabel}
            multiple={false}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                labelFontSize={labelFontSize}
                label={translate('actingBody')}
                items={selectableActingBodies}
                multiple={false}
                setValue={setValue}
                value={value}
                disabled={disabled}
                zIndex={zIndex}
                required={required}
                semiBoldLabel={semiBoldLabel}
            />
        );
    }
}

export default ActingBodiesDropdown;
